/**
 * `required(name)` — fail-fast helper SZERVER-oldali / build-idejű env-ekhez.
 *
 * Dinamikus kulccsal (`process.env[name]`) olvas, ezért CSAK ott használható, ahol
 * valós `process.env` van futásidőben: Node-szerver (next.config.ts rewrites,
 * Route Handler-ek, server component-ek). Itt a hiányzó env futásidőben fail-fast-ol.
 *
 * ⚠️ Kliens (`'use client'`) komponensben NEXT_PUBLIC_*-hoz NEM jó: a Next.js a
 * NEXT_PUBLIC_* értékeket a kliens-bundle-be CSAK statikus literál hivatkozásnál
 * (`process.env.NEXT_PUBLIC_X`) inline-olja, a dinamikus `process.env[name]`
 * lookupot soha — így a böngészőben mindig `undefined` lenne. Kliens-oldalon a
 * `requiredPublic()`-ot kell hívni, a literál `process.env.NEXT_PUBLIC_X`-szel.
 */
export const required = (name: string): string => {
  const v = process.env[name];
  if (!v) throw new Error(`Hiányzó kötelező env: ${name}`);
  return v;
};

/**
 * `requiredPublic(value, name)` — fail-fast a KLIENS-oldali NEXT_PUBLIC_* env-ekhez.
 *
 * A hívó a literál `process.env.NEXT_PUBLIC_X`-et adja át értékként — így a Next.js
 * build-time-on (prod) / dev-szerver-induláskor (uat `next dev`) inline-olja a
 * kliens-bundle-be. A `name` csak a hibaüzenethez kell. Fallback TILOS: ha az érték
 * hiányzik, dobunk (a globális CLAUDE.md szabálya szerint).
 */
export const requiredPublic = (value: string | undefined, name: string): string => {
  if (!value) throw new Error(`Hiányzó kötelező env: ${name}`);
  return value;
};
